export const texts = [
    [
        {
          text: 's',
          count: 200,
          fontSize: 200,
        },
        {
          text: 'sssss',
          count: 400,
          fontSize: 200,
        },
        {
          text: 'still you wait',
          count: 800,
          fontSize: 100,
        },
        {
          text: 'for such',
          count: 1200,
          fontSize: 100,
        },
        {
          text: 's',
          count: 1400,
          fontSize:  200,
        },
        {
          text: 'sssss',
          count: 1600,
          fontSize: 200,
        },
        {
          text: 'silly stuff',
          count: 2000,
          fontSize: 200,
        },
        {
          text: 'such as',
          count: 2400,
          fontSize: 200,
        },
        {
          text: 'singing softshell salamanders',
          count: 2800,
          fontSize: 100,
        },
        {
          text: 'or soupy sardine sandwiches',
          count: 3200,
          fontSize: 100,
        },
        {
          text: '',
          count: 4800,
          fontSize: 400,
        },
      ],
      [
        {
          text: 'CRI',
          count: 100,
          fontSize: 200,
        },
        {
          text: 'RIM',
          count: 300,
          fontSize: 200,
        },
        {
          text: 'IMS',
          count: 500,
          fontSize: 200,
        },
        {
          text: 'MSO',
          count: 700,
          fontSize: 200,
        },
        {
          text: 'SON',
          count: 900,
          fontSize: 200,
        },
        {
          text: 'ONC',
          count: 1100,
          fontSize: 200,
        },
        {
          text: 'NCR',
          count: 1300,
          fontSize: 200,
        },
        {
          text: '',
          count: 1500,
          fontSize: 300,
        },
      ],
      [
        {
          text: 'I see a forest',
          count: 300,
          fontSize: 100,
        },
        {
          text: 'Maybe a jungle',
          count: 600,
          fontSize: 100,
        },
        {
          text: 'Hiding zebras',
          count: 900,
          fontSize: 100,
        },
        {
          text: 'And trees that talk',
          count: 1200,
          fontSize: 100,
        },
        {
          text: 'Whispering secrets',
          count: 1500,
          fontSize: 100,
        },
        {
          text: '',
          count: 1800,
          fontSize: 10,
        },
      ],
      [
        {
          text: 'Follow me',
          count: 300,
          fontSize: 100,
        },
        {
          text: 'Take your stuff',
          count: 600,
          fontSize: 105,
        },
        {
          text: 'Don\'t leave anything behind',
          count: 900,
          fontSize: 100,
        },
        {
            text: 'We may never return',
            count: 1200,
            fontSize: 50,
          },
        {
          text: 'Because we\'re going somewhere',
          count: 1500,
          fontSize: 100,
        },
        {
          text: 'and',
          count: 1800,
          fontSize: 200,
        },
        {
          text: 'never coming back',
          count: 2100,
          fontSize: 50,
        },
        {
            text: '',
            count: 2400,
            fontSize: 10,
        }
      ]
];

export default texts;